<div class="flex items-center gap-2">
  @if (!hideChip()) {
    @if (deposit(); as deposit) {
      <pr-deposit-status-chip class="min-w-0" [deposit]="deposit" />
    } @else if (absence()) {
      <pr-deposit-status-chip class="min-w-0" [absence]="absence()" />
    }
  }

  @if (hasActions() && labelledActions()) {
    <div class="flex flex-wrap items-center gap-2">
      @if (canTakeDeposit()) {
        <button
          mat-stroked-button
          color="primary"
          type="button"
          aria-label="Take Deposit"
          (click)="takeDeposit.emit()"
        >
          <span class="flex items-center gap-2">
            <mat-icon>attach_money</mat-icon>
            <span>Take Deposit</span>
          </span>
        </button>
      }
      @if (canSend()) {
        <button
          mat-stroked-button
          type="button"
          aria-label="Send deposit payment link by email"
          [disabled]="sending()"
          (click)="send(DepositRequestDeliveryChannel.Email)"
        >
          <span class="flex items-center gap-2">
            @if (sendingChannel() === DepositRequestDeliveryChannel.Email) {
              <mat-spinner diameter="20" />
            } @else {
              <mat-icon>email</mat-icon>
            }
            <span>Email link</span>
          </span>
        </button>
        <button
          mat-stroked-button
          type="button"
          aria-label="Send deposit payment link by SMS"
          [disabled]="sending()"
          (click)="send(DepositRequestDeliveryChannel.SMS)"
        >
          <span class="flex items-center gap-2">
            @if (sendingChannel() === DepositRequestDeliveryChannel.SMS) {
              <mat-spinner diameter="20" />
            } @else {
              <mat-icon>sms</mat-icon>
            }
            <span>SMS link</span>
          </span>
        </button>
      }
      @if (canWaive()) {
        <button
          mat-stroked-button
          type="button"
          aria-label="Waive Deposit"
          [disabled]="sending()"
          (click)="waive()"
        >
          <span class="flex items-center gap-2">
            <mat-icon>block</mat-icon>
            <span>Waive deposit</span>
          </span>
        </button>
      }
      @if (canReinstate()) {
        <button
          mat-stroked-button
          type="button"
          aria-label="Reinstate Deposit"
          (click)="unwaive()"
        >
          <span class="flex items-center gap-2">
            <mat-icon>undo</mat-icon>
            <span>Reinstate deposit</span>
          </span>
        </button>
      }
    </div>
  } @else if (hasActions()) {
    <div class="inline-flex items-center gap-1">
      @if (canSend()) {
        <button
          mat-icon-button
          type="button"
          aria-label="Send deposit payment link by email"
          matTooltip="Send deposit payment link by email"
          [disabled]="sending()"
          (click)="send(DepositRequestDeliveryChannel.Email)"
        >
          @if (sendingChannel() === DepositRequestDeliveryChannel.Email) {
            <mat-spinner diameter="20" />
          } @else {
            <mat-icon>email</mat-icon>
          }
        </button>
        <button
          mat-icon-button
          type="button"
          aria-label="Send deposit payment link by SMS"
          matTooltip="Send deposit payment link by SMS"
          [disabled]="sending()"
          (click)="send(DepositRequestDeliveryChannel.SMS)"
        >
          @if (sendingChannel() === DepositRequestDeliveryChannel.SMS) {
            <mat-spinner diameter="20" />
          } @else {
            <mat-icon>sms</mat-icon>
          }
        </button>
      }
      @if (canWaive()) {
        <button
          mat-icon-button
          type="button"
          aria-label="Waive Deposit"
          matTooltip="Waive the deposit"
          [disabled]="sending()"
          (click)="waive()"
        >
          <mat-icon>block</mat-icon>
        </button>
      }
      @if (canReinstate()) {
        <button
          mat-icon-button
          type="button"
          aria-label="Reinstate Deposit"
          matTooltip="Reinstate the deposit"
          (click)="unwaive()"
        >
          <mat-icon>undo</mat-icon>
        </button>
      }
    </div>
  }
</div>
